export const addTrailingSlash = (url: string) => {
	return url + (url.endsWith("/") ? "" : "/");
};
